import { SettingsLayout } from 'modules/settingsContainer/SettingsLayout';
import { DataTab } from 'modules/visualisations/Tree/settings/DataTab';
import { ViewTab } from 'modules/visualisations/Tree/settings/ViewTab';

export const TreeMainSettings = () => {
  return <SettingsLayout DataComponent={DataTab} ViewComponent={ViewTab} />;
};
